"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseContentNode = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("./constants");
const getLighterColor_1 = require("@/utils/getLighterColor");
const BaseContentNode = (props) => {
    var _a, _b;
    const { x, y, width, height, name, subtitle, dataTestId, dataTestIdMain, index, colorMainFillBlocks, fill, colorTrendDirection, colorLabel, root, } = props;
    const maxIndex = ((_b = (_a = root === null || root === void 0 ? void 0 : root.children) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1) - 1;
    const safeMaxIndex = maxIndex > 0 ? maxIndex : 1;
    const lightenFraction = colorTrendDirection === 'desc' ? index / safeMaxIndex : (safeMaxIndex - index) / safeMaxIndex;
    const lightenAmount = lightenFraction * constants_1.MAX_LIGHTEN_FRACTION;
    const isColorTrendDirectionApplied = colorTrendDirection && (colorMainFillBlocks === fill);
    const blockColor = isColorTrendDirectionApplied ? (0, getLighterColor_1.getLighterColor)(colorMainFillBlocks, lightenAmount) : fill;
    const isSubtitleVisible = subtitle && height > constants_1.MIN_VISIBLE_SUBTITLE_CONTENT_HEIGHT;
    const isTitleFit = width < constants_1.MAX_VISIBLE_CONTENT_WIDTH || height < constants_1.MAX_VISIBLE_CONTENT_HEIGHT;
    const testId = dataTestId !== null && dataTestId !== void 0 ? dataTestId : `${dataTestIdMain}-content-node-${index}`;
    if (isTitleFit) {
        return (react_1.default.createElement("g", { "data-test-id": testId },
            react_1.default.createElement("rect", { x: x, y: y, width: width, height: height, fill: blockColor }),
            react_1.default.createElement("text", { x: x + 1, y: y + 12, fill: colorLabel, className: "fds fds-text-ultranarrow" }, constants_1.LABEL_NOT_FIT_REPLACEMENT)));
    }
    return (react_1.default.createElement("g", { "data-test-id": testId },
        react_1.default.createElement("rect", { x: x, y: y, width: width, height: height, fill: blockColor }),
        react_1.default.createElement("text", { x: x + 4, y: y + constants_1.PADDING_TOP_TITLE, fill: colorLabel, className: "fds fds-text-label" }, name),
        isSubtitleVisible && (react_1.default.createElement("text", { x: x + 4, y: y + constants_1.PADDING_TOP_SUBTITLE, fill: colorLabel, className: "fds fds-text-ultranarrow" }, subtitle))));
};
exports.BaseContentNode = BaseContentNode;
